import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ATTRIBUTE_COMPONENTS, CATEGORIES_COMPONENTS, NOTIFICATIONS_COMPONENTS, ORGANIZATION_STRUCTURE_COMPONENTS } from 'src/app/constants/settings-tabs';
import { ApiOrganizationsService, LanguageService, PermissionService } from 'src/app/services';
import { ApiMainSettingsService } from 'src/app/services/api-main-settings.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {


  subscriptions: Subscription = new Subscription();
  language: string;
  treeHeader: boolean = true;
  switchTab: string = 'roles'
  condition: string;
  currentOrg: any;
  checkRole: boolean = true;

  attrComponents = ATTRIBUTE_COMPONENTS;
  notificationComponents = NOTIFICATIONS_COMPONENTS;
  orgStructureComponents = ORGANIZATION_STRUCTURE_COMPONENTS;
  categoriesComponents = CATEGORIES_COMPONENTS;

  constructor(
    private languageService: LanguageService,
    public permissionService: PermissionService,
    private apiSettings: ApiMainSettingsService,
    private apiOrganizations: ApiOrganizationsService
  ) { }

  ngOnInit(): void {

    this.language = this.languageService.getLanguage();
    this.currentOrg = this.apiOrganizations.currentOrganization;

    this.checkOrg();


    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.subscriptions.add(
      this.apiSettings.listenerSwitchTab().subscribe(val => {

        if (val) {

          this.switchTabs(val);
        }

      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
  getComponent(name: string) {

    this.condition = name;
  }

  /**
  * 
  * @param tab 
  */
  switchTabs(tab: string) {

    this.switchTab = tab;

  }

  /**
   * 
   */
  checkOrg() {

    if (this.currentOrg.roles.length > 0) {

      for (let r of this.currentOrg.roles) {

        if (r.name == 'Торговая сеть') {

          this.checkRole = false;
          break;
        }
      }
    }

  }

}
